/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const nestedValidationNodeTemplateSlugRegExp = new RegExp(
    '[-a-zA-Z0-9_]+',
);
export const nestedValidationNodeTemplateNameMax = 256;

export const nestedValidationNodeTemplateDescriptionMax = 1024;

export const NestedValidationNodeTemplate = zod.strictObject({
    id: zod.number(),
    order: zod.number(),
    slug: zod.string().regex(nestedValidationNodeTemplateSlugRegExp),
    name: zod.string().max(nestedValidationNodeTemplateNameMax),
    description: zod
        .string()
        .max(nestedValidationNodeTemplateDescriptionMax)
        .optional(),
    roles_required: zod
        .array(
            zod.strictObject({
                name: zod.string(),
                id: zod.number(),
            }),
        )
        .nullable(),
    can_skip_previous_nodes: zod.boolean().optional(),
});

export type NestedValidationNodeTemplate = zod.input<
    typeof NestedValidationNodeTemplate
>;
export type NestedValidationNodeTemplateOutput = zod.output<
    typeof NestedValidationNodeTemplate
>;
